/**
 * Global Slice
 *
 * Hero-style: full-bleed background image with text overlay.
 */

import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { PrismicRichText } from "@prismicio/react";
import * as styles from "./Global.module.scss";
import { GatsbyImage } from "gatsby-plugin-image";

export const Global = ({ slice }) => {
  const { image, text, color_scheme } = slice?.primary || {};

  return (
    <section
      className={styles.global}
      data-color-scheme={color_scheme || "black"}
      id="global"
    >
      {image?.gatsbyImageData && (
        <GatsbyImage
          image={image.gatsbyImageData}
          alt={image.alt || ""}
          className={styles.backgroundImage}
        />
      )}
      <div className={`page-width ${styles.content}`}>
        <motion.div className={styles.textWrapper}
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {text?.richText && (
            <PrismicRichText
              field={text.richText}
              components={{
                heading1: ({ children }) => (
                  <h2 className={`h1 ${styles.heading}`}>{children}</h2>
                ),
                paragraph: ({ children }) => (
                  <p className={styles.paragraph}>{children}</p>
                ),
              }}
            />
          )}
        </motion.div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment AboutPageDataBodyGlobal on PrismicAboutPageDataBodyGlobal {
    primary {
      image {
        url
        gatsbyImageData(
          width: 1920
          placeholder: BLURRED
          layout: FULL_WIDTH
        )
      }
      text {
        richText
        text
      }
      color_scheme
    }
  }
`;
